import React, { useMemo } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import WhatsappTemplatePreview from "../WhatsappTemplatePreview";
import { i18n } from "../../translate/i18n";
import { parseTemplateComponents } from "../../utils/templateVariables";

const useStyles = makeStyles((theme) => ({
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(2, 2, 1),
  },
  meta: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.75),
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
  content: {
    paddingTop: theme.spacing(1),
  },
}));

function WhatsappTemplatePreviewDialog({
  open,
  onClose,
  template,
  businessName,
}) {
  const classes = useStyles();

  const components = useMemo(() => {
    if (!template?.components) return [];
    return parseTemplateComponents(template.components);
  }, [template]);

  if (!template) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className={classes.titleRow}>
        <div>
          <Typography variant="h6">{template.name}</Typography>
          <div className={classes.meta}>
            <span>{template.language}</span>
            <span>·</span>
            <span>
              {i18n.t(
                `whatsappTemplates.categories.${template.category}`,
                template.category,
              )}
            </span>
            <Chip
              size="small"
              label={i18n.t(
                `whatsappTemplates.status.${template.status}`,
                template.status,
              )}
            />
          </div>
        </div>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers className={classes.content}>
        <WhatsappTemplatePreview
          components={components}
          businessName={businessName}
          emptyText={
            template.bodyPreview ||
            i18n.t("whatsappTemplates.picker.previewEmpty")
          }
          hintText={i18n.t("whatsappTemplates.preview.readOnlyHint")}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          {i18n.t("whatsappTemplates.preview.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WhatsappTemplatePreviewDialog;
